mutation CreateScoreboard(
  $eventId: ID!
  $name: String!
  $title: String
  $titleTextColor: String!
  $dividerColor: String!
  $backgroundColor: String!
  $backgroundImage: String
  $backgroundImageFit: StreamToolsImageFit
  $cornerRadius: Int!
  $borderWidth: Int
  $borderColor: String
  $fontKey: String
  $competitors: [StreamToolsCompetitorInput!]
) {
  scoreboard: StreamToolsCreateScoreboard(
    eventId: $eventId
    name: $name
    title: $title
    titleTextColor: $titleTextColor
    dividerColor: $dividerColor
    backgroundColor: $backgroundColor
    backgroundImage: $backgroundImage
    backgroundImageFit: $backgroundImageFit
    cornerRadius: $cornerRadius
    borderWidth: $borderWidth
    borderColor: $borderColor
    fontKey: $fontKey
    competitors: $competitors
  ) {
    boardId
    eventId
    name
    createdAt
    title
    titleTextColor
    dividerColor
    backgroundColor
    backgroundImage
    backgroundImageFit
    cornerRadius
    borderWidth
    borderColor
    fontKey
    version
    competitors {
      competitorId
      boardId
      name
      score
      nameTextColor
      scoreTextColor
      imageUrl
      scoreImageUrl
    }
  }
}
